import CustomHead from "@components/shared/CustomHead";
import { BillingUI } from "@growthzilla/billingui";

import SignageBillingProvider from "@components/shared/Billing/SignageBillingProvider";
import { LoadingContainer } from "@components/shared/CircularProgressIndicator";
import { useAuth } from "@hooks/useAuth";
import { authClient } from "@utils/authClient";
import { supabase } from "@utils/serverClient";
import { useEffect, useState } from "react";
import { cn } from "@utils/index";
import { useTheme } from "next-themes";

function BillingPage() {
  return (
    <div>
      <CustomHead title="Billing" />

      <BillingPageBody />
    </div>
  );
}

function BillingPageBody() {
  const { user } = useAuth();
  const { organization } = useAuth();
  const { theme, systemTheme } = useTheme()
  const effectTheme = theme === "system" ? systemTheme : theme

  const [hasSession, setHasSession] = useState(false);

  useEffect(() => {
    const fetchSession = async () => {
      const accessToken = await authClient.getAccessToken();

      if (accessToken) {
        setHasSession(true);
      }
    };
    fetchSession();
  }, []);
  if (!user || !organization) return <></>;

  return (
    <div className={cn(effectTheme === "dark" && "dark-mode")}>
      {hasSession ? (
        <SignageBillingProvider>
          <BillingUI />
        </SignageBillingProvider>
      ) : (
        <LoadingContainer />
      )}
    </div>
  );
}

export default BillingPage;
